"use strict";
// Vehicle Data Functions
function renderVehicles(container, vehicles) {
    try {
        const html = `<div class="vehicle-matches-container">
      ${renderMakes(vehicles.makesList)}
    </div>`;
        container.innerHTML = html;
    }
    catch (e) {
        console.error("Render vehicles error", e);
    }
}
function renderMakes(makes) {
    if (!Array.isArray(makes) || makes.length === 0)
        return "<p>No vehicle data available.</p>";
    return makes
        .map((make) => `<div class="vehicle-make-section">
        <div class="vehicle-make-header">${window.escapeHtml(make.make || "")}</div>
        ${renderModels(make.modelsList)}
      </div>`)
        .join("");
}
function renderModels(models) {
    if (!Array.isArray(models) || models.length === 0)
        return "";
    return models
        .map((model) => `<div class="vehicle-model-section">
        <div class="vehicle-model-header">${window.escapeHtml(model.model || "")}</div>
        ${renderSeries(model.seriesList)}
      </div>`)
        .join("");
}
function renderSeries(series) {
    if (!Array.isArray(series) || series.length === 0)
        return "";
    return `<div class="vehicle-series-grid">
    ${series.map((s) => renderSeriesDetails(s)).join("")}
  </div>`;
}
function renderSeriesDetails(series) {
    const yearRange = [series.yearFrom, series.yearTo]
        .filter(Boolean)
        .join(" - ");
    // Render badges if available
    const badges = series.autoGrabSeries?.badgesList || [];
    const badgesHtml = badges.length > 0
        ? `<div class="vehicle-badges">
        ${badges
            .map((badge) => `<span class="vehicle-badge">${window.escapeHtml(badge)}</span>`)
            .join("")}
      </div>`
        : "";
    return `<div class="vehicle-series-card">
    <div class="vehicle-series-name">${window.escapeHtml(series.autoGrabSeries?.series || "")}</div>
    ${badgesHtml}
    <div class="vehicle-specs">
      ${yearRange
        ? `<div class="vehicle-spec">
        <span class="vehicle-spec-label">Year Range</span>
        <span class="vehicle-spec-value vehicle-year-range">${window.escapeHtml(yearRange)}</span>
      </div>`
        : ""}
      ${series.attributes
        ? `<div class="vehicle-spec">
        <span class="vehicle-spec-label">Attributes</span>
        <span class="vehicle-spec-value vehicle-attributes">${window.escapeHtml(series.attributes)}</span>
      </div>`
        : ""}
      ${series.bodyType
        ? `<div class="vehicle-spec">
        <span class="vehicle-spec-label">Body Type</span>
        <span class="vehicle-spec-value vehicle-body-type">${window.escapeHtml(series.bodyType)}</span>
      </div>`
        : ""}
      ${series.doors
        ? `<div class="vehicle-spec">
        <span class="vehicle-spec-label">Doors</span>
        <span class="vehicle-spec-value vehicle-doors">${window.escapeHtml(series.doors.toString())}</span>
      </div>`
        : ""}
      ${series.addedHeight
        ? `<div class="vehicle-spec">
        <span class="vehicle-spec-label">Added Height</span>
        <span class="vehicle-spec-value vehicle-height">${window.escapeHtml(series.addedHeight.toString())}mm</span>
      </div>`
        : ""}
    </div>
  </div>`;
}
// Initialize Vehicle Data
(async function () {
    const vehicleContainer = document.getElementById("bnr-vehicle-data");
    if (vehicleContainer) {
        const gid = vehicleContainer?.dataset?.productGid;
        if (gid) {
            try {
                const version = "2025-10";
                const token = "ecbbf53ca75d6df11c96dd3da02cdc8e";
                const query = `
          query VehicleData($id: ID!) {
            product(id: $id) {
              metafield(namespace: "custom", key: "matching_vehicles") { value }
            }
          }
        `;
                const res = await fetch(`/api/${version}/graphql.json`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": token,
                    },
                    body: JSON.stringify({
                        query,
                        variables: { id: `gid://shopify/Product/${gid}` },
                    }),
                });
                if (res.ok) {
                    const { data } = (await res.json());
                    const json = data?.product?.metafield?.value;
                    if (json) {
                        const vehicles = JSON.parse(json);
                        renderVehicles(vehicleContainer, vehicles);
                    }
                }
            }
            catch (e) {
                console.error("Vehicle data error", e);
            }
        }
    }
})();
